<app-loader *ngIf="mergeBrigadeLoading"></app-loader>
<div class="modal__header">
  <span class="title">Объединение бригад</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXMergeBrigade"></div>
</div>
<div class="modal__body">
  <div class="title title--s" *ngIf="brigadesWithOutSelected && brigadesWithOutSelected.length > 1">Добавить бригады</div>
  <div class="title title--s" *ngIf="brigadesWithOutSelected && brigadesWithOutSelected.length <= 1">Добавить бригаду</div>
  <div class="mt-4 mb-4" *ngFor="let brigade of brigadesWithOutSelected">
    {{ brigade.brigade_name }}
  </div>

  <div class="mt-16">
    <app-field>
      <label>В бригаду</label>
      <app-select
        [items]="brigadesWithOutSelected"
        (callback)="onChangeSelectedBrigade($event)"
        [textKey]="'brigade_name'"
        [defaultText]="'Выберите бригаду'"
        [initBy]="brigadeSelected"
        [name]="'brigadeName'"
      ></app-select>
    </app-field>
    <div class="text-italic color-gray-dark font-size-12 mt-4">
      <div *ngIf="brigadesWithOutSelected && brigadesWithOutSelected.length > 1">
        Заявки, назначенные на бригады, будут переназначены на <br />
        выбранную бригаду.
      </div>
      <div *ngIf="brigadesWithOutSelected && brigadesWithOutSelected.length <= 1">
        Заявки, назначенные на бригаду, будут переназначены на <br />
        выбранную бригаду.
      </div>
    </div>
  </div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" (click)="onMergeBrigades()" [disabled]="!brigadeSelected" id="appMergeBrigades">Объединить</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseMergeBrigade"> Отмена </a>
  </div>
</div>
